export const getUrlParams = () => {
    if (typeof window !== `undefined`) {
      return window.location.search
        .substr(1)
        .split("&")
        .map(el => el.split("="))
        .reduce((acc, arr) => ((acc[arr[0]] = arr[1]), acc), {})
    } else return {}
  }

const TIME = 3600 * 24 * 90

export const setCookie = (name, value) =>
  (document.cookie = `${name}=${value}; max-age=${TIME}`)

export const checkPromoter = () => {
  const { admitad_uid, aff_sub } = getUrlParams()

  const promoter =
    typeof window !== `undefined`
      ? document.cookie.replace(
          /(?:(?:^|.*;\s*)admitad_uid\s*\=\s*([^;]*).*$)|^.*$/,
          "$1"
        )
      : ""

  const source =
    typeof window !== `undefined`
      ? document.cookie.replace(
          /(?:(?:^|.*;\s*)source\s*\=\s*([^;]*).*$)|^.*$/,
          "$1"
        )
      : ""

  if (!admitad_uid && !aff_sub) {
    console.log({ promoter, source })
    return { id: promoter, source }
  }

  // admitad in url
  if (admitad_uid) {
    if (promoter && promoter === admitad_uid) {
      setCookie("source", "admitad")
      return { id: admitad_uid, source: "admitad" }
    } else {
      setCookie("admitad_uid", admitad_uid)
      setCookie("source", "admitad")
      return { id: admitad_uid, source: "admitad" }
    }
  }

  // aff_sub param in url
  if (aff_sub) {
    if (promoter && promoter === aff_sub) {
      setCookie("source", "aff_sub")
      return { id: aff_sub, source: "aff_sub" }
    } else {
      setCookie("admitad_uid", aff_sub)
      setCookie("source", "aff_sub")
      return { id: aff_sub, source: "aff_sub" }
    }
  }

  console.log("promoter", promoter)
  console.log("source", source)

  return { id: promoter, source }
}